export const module15InitialState = {
  module15: {
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    StudentID: '',
    moduleID: '',
    keys: 0,
    coins: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      TreeHouseRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      TreeHouseBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Alien1: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Alien2: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      TelescopeRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      TelescopeBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      CometBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      CometOrange: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Deer: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Doe: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Planet1: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Planet2: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Swing: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      TireSwing: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Rocket1: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Rocket2: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      BigNorthernLights: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Galaxy: {
        unlocked: false,
        x: 0,
        y: 0,
      },
    },
    unlockedDays: {
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
    },
  },
};

export const Module15Reducer = (state = module15InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE15_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed !== null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed!== null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        TreeHouseRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        TreeHouseBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Alien1: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Alien2: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        TelescopeRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        TelescopeBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        CometBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        CometOrange: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Deer: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Doe: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Planet1: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Planet2: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Swing: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        TireSwing: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Rocket1: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Rocket2: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        BigNorthernLights: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Galaxy: {
          unlocked: false,
          x: 0,
          y: 0,
        },
      };
      let tempObj = action.payload?.game_details;
      if (tempObj !== 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]].unlocked = true;
              tempRewards[Object.keys(tempRewards)[j]].x = obj[i]?.x_multiplier;
              tempRewards[Object.keys(tempRewards)[j]].y = obj[i]?.y_multiplier;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[], "tokens_earned":0}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day4: false,
        day5: false,
        day6: false,
        day7: false,
        day8: false,
      };
      if (action.payload?.day_completed !== null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"TreeHouseRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachChairRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"TelescopeRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"CometBlue\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"Rocket2\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module15: {
          ...state.module15,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
          coins: JSON.parse(tempObj)?.tokens_earned,
        },
      };
    }

    case 'CLEAR': {
      return {
        ...module15InitialState,
      };
    }
    case 'MODULE15_SET_DAY': {
      return {
        ...state,
        module15: {
          ...state.module15,
          currentday: action.payload,
        },
      };
    }

    case 'MODULE15_SET_GameDetials': {
      return {
        ...state,
        module15: {
          ...state.module15,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE15_SET_stepCompleted': {
      return {
        ...state,
        module15: {
          ...state.module15,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE15_SET_dayCompleted': {
      return {
        ...state,
        module15: {
          ...state.module15,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE15_SET_CAMERAOPEN': {
      return {
        ...state,
        module15: {
          ...state.module15,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE15_SET_KEY': {
      return {
        ...state,
        module15: {
          ...state.module15,
          keys: action.payload,
        },
      };
    }
    case 'MODULE15_SET_COIN': {
      return {
        ...state,
        module15: {
          ...state.module15,
          coins: action.payload,
        },
      };
    }
    case 'MODULE15_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module15: {
          ...state.module15,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE15_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module15: {
          ...state.module15,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE15_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module15: {
          ...state.module15,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE15_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module15: {
          ...state.module15,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE15_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module15: {
          ...state.module15,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE15_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module15: {
          ...state.module15,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE15_SET_REWARD11': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            TreeHouseRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD11_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            TreeHouseRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD12': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            TreeHouseBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD12_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            TreeHouseBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD21': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Alien1: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD21_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Alien1: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD22': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Alien2: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD22_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Alien2: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD31': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            TelescopeRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD31_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            TelescopeRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD32': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            TelescopeBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD32_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            TelescopeBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD41': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            CometBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD41_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            CometBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD42': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            CometOrange: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD42_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            CometOrange: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD51': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Deer: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD51_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Deer: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD52': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Doe: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD52_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Doe: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD61': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Planet1: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD61_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Planet1: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD62': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Planet2: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD62_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Planet2: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD71': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Swing: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD71_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Swing: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD72': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            TireSwing: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD72_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            TireSwing: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD81': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Rocket1: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD81_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Rocket1: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD82': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Rocket2: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_REWARD82_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Rocket2: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_PRIZE1': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            BigNorthernLights: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_PRIZE1_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            BigNorthernLights: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_PRIZE2': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Galaxy: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_PRIZE2_POSITION': {
      return {
        ...state,
        module15: {
          ...state.module15,
          rewards: {
            ...state.module15.rewards,
            Galaxy: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE15_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module15: {
          ...state.module15,
          unlockedDays: {
            ...state.module15.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE15_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module15: {
          ...state.module15,
          unlockedDays: {
            ...state.module15.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE15_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module15: {
          ...state.module15,
          unlockedDays: {
            ...state.module15.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE15_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module15: {
          ...state.module15,
          unlockedDays: {
            ...state.module15.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE15_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module15: {
          ...state.module15,
          unlockedDays: {
            ...state.module15.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE15_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module15: {
          ...state.module15,
          unlockedDays: {
            ...state.module15.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE15_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module15: {
          ...state.module15,
          unlockedDays: {
            ...state.module15.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE15_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module15: {
          ...state.module15,
          unlockedDays: {
            ...state.module15.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }

    default:
      return state;
  }
};
export default Module15Reducer;
